import React from "react";
import Profile from "../components/profile/profile";

export default function perfil() {
  return <Profile />;
}
